export const projectedTooltip =
    "Projected extends today's completed count forward using your marketing plan's cadence for the rest of the month.";

export const gapLabel = (projected: number, target: number): string => {
    const gap = projected - target;
    if (gap === 0) {
        return "On goal";
    }
    return `${Math.abs(gap)} ${gap < 0 ? "below" : "above"} goal`;
};

export const gapColorClass = (value: number, baseline: number): string => {
    const gap = value - baseline;
    if (gap < 0) {
        return "text-rose-700";
    }
    if (gap > 0) {
        return "text-emerald-700";
    }
    return "text-gray-500";
};
